"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fonts = void 0;
const theme_1 = require("./theme");
const defaultPalette = theme_1.theme.palette;
class Fonts {
    constructor(theme = { palette: {} }) {
        this.get = (kind = 'ui', scale = 'mid', index = 0) => {
            const fonts = this.palette[kind] ?? defaultPalette[kind] ?? defaultPalette.ui;
            const wrappedIndex = index % fonts.length;
            const font = fonts[wrappedIndex];
            const style = font[scale] ?? defaultPalette.ui[0][scale];
            return style;
        };
        this.palette = theme.palette;
    }
}
exports.Fonts = Fonts;
